import React from 'react';

import InfoIcon from '@mui/icons-material/Info';

// Shown when the appointment already has today's note. BlinkScribe keeps one
// note per visit (the backend merges same-day recordings into it anyway), so
// the only choices are to add to that note or to cancel.
const SameDayNoteModal = ({ isModalOpen, handlecombine }) => {
  if (!isModalOpen) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-50"
    >
      <div className="relative p-4 w-full max-w-lg max-h-full">
        <div className="relative bg-white rounded-lg shadow ">
          <div className="p-4 md:p-5  text-center">
            <div>
              <InfoIcon />
            </div>

            <div className="mb-2 mt-3  font-sans text-lg font-[400]">
              This visit already has a note from today.
            </div>
            <div className="font-sans text-sm text-gray-600">
              Each visit keeps one note. New audio is added to today's note.
            </div>

            <div className="flex items-center justify-center mt-4 gap-5 w-full">
              <button
                onClick={() => handlecombine('combine')}
                className="w-max p-4 h-10 bg-[#1c2a3a] text-white text-sm font-semibold rounded-[14px] flex items-center justify-center">
                Add to today's note
              </button>
              <button
                onClick={() => handlecombine('cancel')}
                className="w-max p-4 h-10 bg-[#FFF] text-[#232222] border border-[#CBCBCB] text-sm font-semibold rounded-[14px] flex items-center justify-center">
                Cancel
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SameDayNoteModal;
